import * as Sentry from '@sentry/react';
import { SENTRY_ENABLED } from '../constants';

export const sendToSentry = (error, errorInfo) => {
  if (SENTRY_ENABLED) {
    Sentry.setExtras(errorInfo);
    Sentry.captureException(error);
  } else {
    // eslint-disable-next-line
    console.error(error, errorInfo);
  }
};

// A fingerprinted warning event, for a fallback that would otherwise pass silently.
export const reportWarning = (message, { extras, fingerprint }) => {
  if (SENTRY_ENABLED) {
    Sentry.withScope((scope) => {
      scope.setFingerprint(fingerprint);
      scope.setExtras(extras);
      Sentry.captureMessage(message, 'warning');
    });
  } else {
    // eslint-disable-next-line
    console.warn(message, extras);
  }
};

// Tags every later event from this page load.
export const setSentryTag = (key, value) => {
  if (SENTRY_ENABLED) {
    Sentry.setTag(key, value);
  }
};
